import { AdminMenuItem } from '../admin/adminMenu';

export const employeeMenuItems: AdminMenuItem[] = [
  { label: 'Expense History & Status', path: '/employee/dashboard', icon: '▦' },
  { label: 'Trips', path: '/employee/trips', icon: '✈' },
  { label: 'Upload Invoice', path: '/employee/invoices', icon: '⇪' },
  { label: 'Reimbursement Status', path: '/employee/dashboard', icon: '₹' },
  { label: 'Add Expense', path: '/employee/expenses/new', icon: '＋' },
];
